// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2_x0r","text":"Header_text__pCBu5","image":"Header_image__147ug"};